var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThirty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #d8d8d8;\n      }\n\n      .cls-2 {\n        fill: #cccccb;\n      }\n\n      .cls-3 {\n        fill: #1f2f60;\n      }\n\n      .cls-4 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Taxes"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1017.73,906.87l-92.03-91.87c-6.32-6.38-16.62-6.42-22.99-.09-.03.03-.06.06-.09.09l-45.85,45.85c-6.38,6.32-6.42,16.62-.09,22.99.03.03.06.06.09.09,97.56,97.56,99.67,106.18,126.34,106.18,26.94.07,48.83-21.72,48.9-48.66.03-12.97-5.1-25.41-14.27-34.59h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M804.41,985.24c0,26.94-21.84,48.78-48.78,48.78H137.76c-26.34.55-48.16-20.33-48.78-46.67V137.62c.62-26.34,22.44-47.21,48.78-46.67,522.1,0,489.09,0,493.97,1.3s-7.48-9.43,167.96,166.01c7.15,7.15,4.72-33.01,4.72,726.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M316.62,172.25c-26.94,0-48.78,21.84-48.78,48.78v260.15c0,8.98,7.28,16.26,16.26,16.26h65.04c8.98,0,16.26-7.28,16.26-16.26V221.03c0-26.94-21.84-48.78-48.78-48.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M446.69,253.55c-26.94,0-48.78,21.84-48.78,48.78v178.86c0,8.98,7.28,16.26,16.26,16.26h65.04c8.98,0,16.26-7.28,16.26-16.26v-178.86c0-26.94-21.84-48.78-48.78-48.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M576.77,334.85c-26.94,0-48.78,21.84-48.78,48.78v97.56c0,8.98,7.28,16.26,16.26,16.26h65.04c8.98,0,16.26-7.28,16.26-16.26v-97.56c0-26.94-21.84-48.78-48.78-48.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M625.55,497.45h-357.71c-8.98,0-16.26-7.28-16.26-16.26s7.28-16.26,16.26-16.26h357.71c8.98,0,16.26,7.28,16.26,16.26s-7.28,16.26-16.26,16.26Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M597.1,611.27H251.58c-8.98,0-16.26-7.28-16.26-16.26s7.28-16.26,16.26-16.26h345.52c8.98,0,16.26,7.28,16.26,16.26s-7.28,16.26-16.26,16.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M560.51,708.82H251.58c-8.98,0-16.26-7.28-16.26-16.26s7.28-16.26,16.26-16.26h308.93c8.98,0,16.26,7.28,16.26,16.26s-7.28,16.26-16.26,16.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M578.24,806.38H251.58c-8.98,0-16.26-7.28-16.26-16.26s7.28-16.26,16.26-16.26h326.66c8.98,0,16.26,7.28,16.26,16.26s-7.28,16.26-16.26,16.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M676.61,903.94H251.58c-8.98,0-16.26-7.28-16.26-16.26s7.28-16.26,16.26-16.26h425.03c8.98,0,16.26,7.28,16.26,16.26s-7.28,16.26-16.26,16.26Z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 755.63,
    cy: 708.82,
    r: 211.38
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M794.33,284.77c-4.39,1.79,5.69,1.3-136.26,1.3-26.94,0-48.78-21.83-48.79-48.77,0-.38,0-.77.01-1.15V107.22c.04-8.98,7.36-16.22,16.34-16.18,2.09.01,4.16.42,6.1,1.22,4.88,2.11-7.48-9.43,167.96,166.01,6.33,6.37,6.3,16.67-.08,22.99-1.52,1.51-3.31,2.7-5.29,3.51h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M827.01,717.77c-26.59,4.31-44.66,29.35-40.36,55.95,4.31,26.59,29.35,44.66,55.95,40.36,12.75-2.06,24.15-9.1,31.72-19.56,15.79-21.83,10.9-52.32-10.93-68.11-10.5-7.6-23.59-10.7-36.39-8.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M684.25,699.88c26.58-4.49,44.49-29.68,40-56.26-4.49-26.58-29.68-44.49-56.26-40-62.27,10.08-48.29,106.5,16.26,96.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M809.12,607.04l-133.33,184.55c-5.21,7.32-3.5,17.47,3.81,22.68,2.73,1.95,6,3,9.36,3.01,11.87,0,3.25,7.15,146.34-191.21,4.54-7.75,1.93-17.71-5.82-22.25-6.69-3.91-15.21-2.57-20.36,3.22h0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThirty);
export default __webpack_public_path__ + "static/media/thirty.5ec477f1ea44d39bdc20117a33d073d3.svg";
export { ForwardRef as ReactComponent };